import {
  Directive,
  TemplateRef,
  Input,
  OnInit,
} from '@angular/core';

@Directive({
  selector: '[intTableChild]',
})
export class TableChildDirective implements OnInit {
  @Input('intTableChild')
  public type: string | Array<string> = '';
  constructor(public templateRef: TemplateRef<any>) {}

  ngOnInit(): void {}
}
